function medal_Reducer(state = [], action) {
    switch (action.type) {
        case 'MEDAL/SET':
            return action.medal;
        case 'MEDAL/CLEAR':
            return null;
        default:
            return state;
    }
}

export default medal_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/medal.js